import { ProjectResourceType } from 'src/constants/project';
import { NodeCategory } from 'src/containers/ProjectDiagram/constants/categories';
import {
  DeletedResource,
  FileUpload,
  VirtualGraph,
} from 'src/containers/ProjectDiagram/types/data';

export const replaceDeletedResourceKey = (key: string) =>
  key.replace(
    new RegExp(`^${NodeCategory.RESOURCE}-`),
    `${NodeCategory.DELETED_RESOURCE}-`
  );

export const createDeletedResource = (
  existing: FileUpload | VirtualGraph
): DeletedResource => ({
  key: replaceDeletedResourceKey(existing.key),
  value: existing.value,
  text: existing.text,
  type: existing.type,
  category: NodeCategory.DELETED_RESOURCE,
  pos: existing.pos,
  ...(existing.type === ProjectResourceType.VIRTUAL_GRAPH
    ? {
        dataSourceType: existing.dataSourceType,
      }
    : {}),
});
